import type { SentryLike } from './sentryLike';

let _sdk: SentryLike | null = null;
let _serviceTag: string = 'frontend';

/**
 * Called once by the host app (fe-main root.jsx, Next.js sentry.client.config.ts, etc.)
 * immediately after importing the real Sentry package and before rendering.
 * The shared observability helpers are no-ops until this is called.
 */
export function registerSentrySdk(sdk: SentryLike, serviceTag?: string): void {
	_sdk = sdk;
	if (serviceTag) _serviceTag = serviceTag;
}

/**
 * Internal helper for observability modules.
 * Returns null when called before registerSentrySdk (graceful no-op in tests / SSR).
 */
export function getSentrySdk(): SentryLike | null {
	if (_sdk === null && typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') {
		console.warn(
			'[observability] Sentry SDK not registered yet. Call registerSentrySdk(sdk) in your app entry before using trackError / setFrontendContext.',
		);
	}
	return _sdk;
}

/** Returns the service tag set at registration time. */
export function getServiceTag(): string {
	return _serviceTag;
}
